import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function DashIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "#C9C9C9";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Dash">
          <path
              d="M0.75 12.038H23.25"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
          />
      </SvgIcon>
  );
}